/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {PERCENTAGE_FIELDS} from './percent-fields';

export function formatCsvOutput(stat: any, field?: string): any {
  if (_.isDate(stat)) {
    return stat;
  }
  if (_.isNull(stat) || _.isNaN(stat) || _.isUndefined(stat)) {
    return '';
  }
  if (field && _.isObject(stat) && _.has(stat, field)) {
    const objValue = stat[field];
    if (_.isFinite(objValue)) {
      return (objValue || 0).toString();
    }
    // A custom event's averageValue can itself be a monetary object ({currency, amount}).
    if (_.has(objValue, 'currency')) {
      return (objValue.amount || 0).toString();
    }
  }
  if (_.isFinite(stat)) {
    return field && PERCENTAGE_FIELDS[field] ? stat * 100 : stat;
  }
  if (_.has(stat, 'currency')) {
    return stat.amount.toString();
  }
  return stat;
}
